import { ThemeProviderContextProps, tokens } from "@vintecc/components";
import { create } from "zustand";

interface ThemeState {
  theme: "light" | "dark";
  currentThemeConfig: ThemeProviderContextProps["theme"];
  setTheme: (theme: "light" | "dark") => void;
}

const darkTheme: ThemeProviderContextProps["theme"] = {
  theme: {
    border: { color: "#41425A" },
    surface: {
      neutralBackground1: tokens.color.blue[700],
      neutralBackground2: tokens.color.blue[700],
      neutralBackground3: "linear-gradient(142deg, #1d1d34 0%, #161727 100%)",
      neutralBackground4: tokens.color.blue[600],
      navBackground: tokens.color.blue[700],
      overlayBackground: tokens.color.blue[400],
      neutralHoverBackground1: tokens.color.blue[500],
    },
    text: {
      color: tokens.color.white[100],
      secondary: { color: tokens.color.white[100] },
    },
    input: {
      menu: {
        background: tokens.color.blue[500],
        hover: { background: tokens.color.blue[600] },
      },
      background: tokens.color.blue[700],
      disabled: { background: tokens.color.blue[500] },
    },
    scrollbar: {
      thumb: tokens.color.blue[500],
      track: tokens.color.blue[600],
    },
  },
  component: {
    table: { row: { hover: { background: tokens.color.blue[600] } } },
    navigation: {
      item: {
        active: {
          background: "linear-gradient(145deg, #181931 0%, #171c34 100%)",
        },
      },
    },
    input: { shadow: "0 6px 20px 0 rgba(124, 130, 255, 0.11)" },
    panel: { header: { background: tokens.color.blue[700] } },
  },
};

export const useThemeStore = create<ThemeState>((set) => ({
  theme: "light",
  currentThemeConfig: {
    component: {
      modal: {
        background: tokens.color.white[100],
      },
    },
  },
  setTheme: (theme: "light" | "dark") =>
    set({
      theme,
      currentThemeConfig: theme === "light" ? {} : darkTheme,
    }),
}));
